import ApiService from "@/service/api";

export const WhitelistService = {

    getAuthWhitelist() {
        return ApiService.get("/external/auth_ip_whitelist");
    },

    addAuthWhitelist(ip_address, mask) {
        const params = { ip_address };
        if (mask !== null && mask !== undefined && mask !== '') {
            params.mask = parseInt(mask, 10);
        }
        return ApiService.post("/external/auth_ip_whitelist", params);
    },

    deleteAuthWhitelist(entry_id) {
        return ApiService.delete(`/external/auth_ip_whitelist/${entry_id}`);
    },

    getApiKeyWhitelist() {
        return ApiService.get("/external/api_key_ip_whitelist");
    },

    addApiKeyWhitelist(ip_address, mask) {
        const params = { ip_address };
        if (mask !== null && mask !== undefined && mask !== '') {
            params.mask = parseInt(mask, 10);
        }
        return ApiService.post("/external/api_key_ip_whitelist", params);
    },

    deleteApiKeyWhitelist(entry_id) {
        return ApiService.delete(`/external/api_key_ip_whitelist/${entry_id}`);
    },
};
